export function persistOnLS(key: string, value: unknown) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    console.warn(`Error setting ${key} to local storage`);
    return {};
  }
}

export function getValueFromLS(key: string) {
  if (typeof window === 'undefined') return;
  try {
    const rawLSValue = localStorage.getItem(key);
    const parsedLSValue = rawLSValue ? JSON.parse(rawLSValue) : {};
    return parsedLSValue;
  } catch {
    console.warn(`Error getting ${key} from local storage`);
    return;
  }
}
